/* eslint-disable react/require-default-props */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  ListItemTextNav, NavItem, style, Container, Row,
} from './styles';

interface Props {
  icon?: JSX.Element,
  name?: string;
  route?: string;
  onPress?: Function,
  isArrow?: boolean;
  arrow?: JSX.Element;
}

const ItemListSideMenu: React.FC<Props> = ({
  icon, name, onPress, route, isArrow, arrow,
}) => {
  const handleNavigation = () => {
    if (route) {
      return (
        <>
          <Container>
            {/* @ts-ignore */}
            <Link to={route || null} style={style}>
              <NavItem onClick={() => (onPress ? onPress() : null)}>
                {icon}
                <ListItemTextNav>{name}</ListItemTextNav>
                {isArrow && (
                  arrow
                )}
              </NavItem>
            </Link>
          </Container>
        </>
      );
    }
    return (
      <Container>
        <NavItem defaultValue={isArrow ? 0 : 1} onClick={() => (onPress ? onPress() : null)}>
          <Row>
            {icon}
            <ListItemTextNav>{name}</ListItemTextNav>
          </Row>
          {isArrow && (
            arrow
          )}
        </NavItem>
      </Container>
    );
  };
  return (
    <>
      {handleNavigation()}
    </>
  );
};
export default ItemListSideMenu;
